import React, { useMemo, useState } from 'react'
import SearchFromTheList from '../../../../../generic/customSearchComponents/SearchFromTheList'
import { problemStatuses } from '../hooks/useProblemHelpers'

type Props = {
  selectedProblemStatus: number
  setSelectedProblemStatus: React.Dispatch<React.SetStateAction<number>>
  required?: boolean
}
const statusList = Object.entries(problemStatuses).map(([key, value]) => ({
  id: +key,
  desc: value
}))

const SearchProblemStatus = ({
  selectedProblemStatus,
  setSelectedProblemStatus,
  required
}: Props) => {
  console.log(statusList)
  const defaultProblemStatusItem = statusList.find(item => item.id === selectedProblemStatus)
  const [isOpenList, setIsOpenList] = useState<boolean>(false)
  const [search, setSearch] = useState<string>(defaultProblemStatusItem?.desc.trim() || '')
  const [statusItem, setStatusItem] = useState<{id: number, desc: string} | null>(defaultProblemStatusItem || null)
  
  const handleSearch = (e: string) => {
    if(e === '') {
      setStatusItem(null)
      setSelectedProblemStatus(0)
      setIsOpenList(false)
      setSearch('')
      return
    }
    setIsOpenList(true)
    setSearch(e)
  }
  const handleSelect = (item: {id: number, desc: string}) => {
    setSearch(item.desc?.trim() || '')
    setIsOpenList(false)

    setStatusItem(item)
    setSelectedProblemStatus(item.id)
  }
  const renderList = useMemo(() => {
    if(!statusList) return []
    return statusList.filter(item => item.desc.trim().toLowerCase().includes(search.toLowerCase()))
  }, [search])
  return (
    <SearchFromTheList 
    
    isOpenList={isOpenList}
      placeHolder={'חפש סטטוס פניה'}
      list={renderList}
      itemDisplayName='desc'
      nameIdElement='id'
      isNeedFullObject
      searchFunc={handleSearch}
      selectFunc={handleSelect}
      size={'full'}
      input={search}
      required={required}
    />
  )
}

export default SearchProblemStatus

